/* eslint-disable no-undef */
import React from 'react';
import { Link } from 'react-router-dom';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';

export default function TemplateDashboard() {
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="Dashboard" linkIcon="/images/icons/speedometer.svg" />
        <ul>
          <li>
            <a href={process.env.REACT_APP_ACCESSKEY_FINANCE_RESULT} target="_blank" rel="noreferrer">
              Indicadores de Resultado Financeiro
            </a>
          </li>
          <li>
            <a href={process.env.REACT_APP_ACCESSKEY_HOSPITAL_FAT} target="_blank" rel="noreferrer">
              Indicadores do Faturamento Hospitalar
            </a>
          </li>
          <li>Indicadores de Produtividade</li>
          <li>Indicadores de Gargalos de Processo</li>
          <li>
            <Link to="/novo-sistema/controladoria/dashboard/budget-actual-forecast">Budget | Actual | Forecast</Link>
          </li>
        </ul>
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
